export const getters = {
    getPerfil: state => state.perfil,
    getPerfis: state => state.perfis,
    getPerfilPermissoesSelecionadas: state => state.perfilPermissoesSelecionadas,
    getModalCadastroPerfil: state => state.modalCadastrarPerfil,
    getModalExcluirPerfil: state => state.modalExcluirPerfil,
    getModalPesquisarPerfil: state => state.modalPesquisarPerfil
}

export default {}